import { axios } from "./axios";
import storage from "../utils/storage";

// Employee list shared by the add/edit modals. One entry only (bounded), short TTL,
// concurrent callers share one request, and the entry is keyed by the auth token so a
// different session never receives another user's data. Employee writes must invalidate.
const TTL_MS = 60 * 1000;
let entry = null; // { token, at, promise }

export function getEmployees() {
  const token = storage.getToken();
  if (entry && entry.token === token && Date.now() - entry.at < TTL_MS) {
    return entry.promise;
  }
  const promise = axios.get("/employees");
  entry = { token, at: Date.now(), promise };
  promise.catch(() => {
    if (entry && entry.promise === promise) entry = null;
  });
  return promise;
}

export function invalidateEmployees() {
  entry = null;
}
